import React from 'react';
import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash-es';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { ValidationError } from 'pages/upload.page/publish-video/fragments';
import { ToolTip } from '../tool-tip';

const Label = ({ text, hashtagSupport }) => {
  const { t } = useTranslation();

  return !isNil(text) ? (
    <>
      <label className="label">{text}</label>
      {hashtagSupport && (
        <ToolTip
          id={'video-desc-tooltip'}
          icon={faQuestionCircle}
          text={t('video_metadata_description_hashtag_tootltip')}
        />
      )}
    </>
  ) : null;
};

export const TextArea = ({ input, label, hashtagSupport, type, placeholder, value, meta: { touched, error } }) => (
  <div className="form-group">
    <Label text={label} hashtagSupport={hashtagSupport} />
    <textarea
      {...input}
      rows="3"
      className={error ? 'form-control validation-error-border' : 'form-control'}
      placeholder={placeholder}
    />
    <ValidationError error={error} />
  </div>
);
